import { render, staticRenderFns } from "./ActiveProcess.vue?vue&type=template&id=ba9c5234&scoped=true&lang=html&"
import script from "./ActiveProcess.vue?vue&type=script&lang=js&"
export * from "./ActiveProcess.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProcess.vue?vue&type=style&index=0&id=ba9c5234&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9c5234",
  null
  
)

export default component.exports